globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.Flash = (function()
{
  function Flash($html) {
    if($html.length === 1)
    {
      this.$html   = $html;
      this.$flashs = this.$html.find('.flash');
      this.init();
    }
  }

  Flash.prototype = {
    _hideFlash: function(){
      me = this;
      this.$flashs.removeClass('fadeInRight')
                  .addClass('fadeOutRight');
      setTimeout(function(){
        me.$html.remove();
      }, 2000);
    },
    init: function(){
      me = this;
      setTimeout(function(){
        me._hideFlash();
      }, 5000);
    }
  }

  return Flash;
})();
